export default "__VITE_ASSET__CaD05W8i__"